var initialQty = 1;
const qty_input = jQuery('#Quantity-product-template');

jQuery('.qtyPlus').on('click',function(e){
	e.preventDefault();
    let newQty = parseInt(qty_input.val()) + 1;
  	jQuery('#Quantity-product-template').val(newQty)
})

jQuery('.qtyMinus').on('click',function(e){
	e.preventDefault();
  	let newQty = parseInt(qty_input.val()) - 1;
  if(newQty <= 0){
  	newQty = 1;
  }
  	jQuery('#Quantity-product-template').val(newQty)
  
})

jQuery('#SingleOptionSelector-0').on('change',function(){
    setTimeout(function(){
      var priceHTML = jQuery('.product__price .price--on-sale').length ? jQuery('.product__price .price-item--sale').html() : jQuery('.product__price .price-item--regular').html();
      const newPrice = `
        Add to cart  | <span class="btnprice" data-regular-price="">${priceHTML}</span>
      `
      jQuery('.product-form__cart-submit span[data-add-to-cart-text]').html(newPrice);
    }, 100);  
})
jQuery(".accordion_head").click(function () {
  if (jQuery('.accordion_body').is(':visible')) {
    jQuery(".accordion_body").slideUp(300);
    jQuery(".plusminus").text('+');
  }
  if (jQuery(this).next(".accordion_body").is(':visible')) {
    jQuery(this).next(".accordion_body").slideUp(300);
    jQuery(this).children(".plusminus").text('+');
  } else {
    jQuery(this).next(".accordion_body").slideDown(300);
    jQuery(this).children(".plusminus").text('-');
  }
});




jQuery("[data-mobile-menu]").click(function(){
    jQuery(this).toggleClass('open');  
	jQuery(".main-menu").slideToggle();  
});



jQuery('.slider-home').owlCarousel({
  loop: true,
  dots: true,
  // margin: 10,

  
  // navText: [
  //   "<i class='fa fa-caret-left'></i>",
  //   "<i class='fa fa-caret-right'></i>"
  // ],

 
  autoplay: true,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1,
      autoHeight: true
    },
    576: {
      items: 1,
      autoHeight: true
    },
    768: {
      items: 1,
      autoHeight: true
    },
    800: {
      items: 1,
      autoHeight: false
    },
    1000: {
      items: 1
    },
    1280: {
      items: 1
    }
  }
});


jQuery('.blog-post-slider').owlCarousel({
  loop: true,
  dots: true,
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  nav: true,
  navText: [
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-left.png?v=1622709544'>",
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-right.png?v=1622709544'>"
  ],
  autoplay: true,
  autoplayTimeout:5000,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1,
      margin: 0,
    },
    576: {
      items: 2,
      margin: 10
    },
    768: {
      items: 3,
      margin: 0,
    },
    1280: {
      items: 5
    }
  }
});

jQuery('#opallac-using').owlCarousel({
  loop: true,
  dots: false,
  margin: 20,
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  nav: true,
  navText: [
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-left.png?v=1622709544'>",
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-right.png?v=1622709544'>"
  ],
  autoplay: true,
  autoplayTimeout:5000,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 2,
      margin: 10
    },
    680: {
      items: 3
    },
    800: {
      items: 4,
      margin: 20
    },
    1280: {
      items: 5
    },
    1440: {
      items: 8
    }
  }
});
jQuery('#opallac-social').owlCarousel({
  loop: true,
  dots: false,
  margin: 20,
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  nav: true,
  navText: [
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-left.png?v=1622709544'>",
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-right.png?v=1622709544'>"
  ],
  autoplay: true,
  autoplayTimeout:5000,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 2,
      margin: 10
    },
    680: {
      items: 3
    },
    800: {
      items: 4,
      margin: 20
    },
    1280: {
      items: 5
    },
    1440: {
      items: 8
    }
    
  }
});



jQuery('#opallac-collections .collections-wrp').owlCarousel({
  loop: true,
  dots: false,
  nav: false,
  margin: 20,
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  nav: true,
  navText: [
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-left.png?v=1622709544'>",
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-right.png?v=1622709544'>"
  ],
  autoplay: true,
  autoplayTimeout:5000,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 2
    },
    800: {
      items: 3
    },
    1280: {
      items: 4
    }
  }
})



jQuery('.blog-details-bottom').owlCarousel({
  loop: true,
  dots: true,
  // margin: 10,

  
  // navText: [
  //   "<i class='fa fa-caret-left'></i>",
  //   "<i class='fa fa-caret-right'></i>"
  // ],

 
  // autoplay: true,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1
    },
    576: {
      items: 1
    },
    768: {
      items: 1
    },
    800: {
      items: 1
    },
    1000: {
      items: 1
    },
    1280: {
      items: 1
    }
  }
})


jQuery(window).scroll(function() {

if (jQuery(this).scrollTop() > 1){  
    jQuery('header').addClass("sticky");
  }
  else{
    jQuery('header').removeClass("sticky");
  }
  
});


 var winWidth = jQuery(window).width(); 

  var headWidth = jQuery(window).width();
  if (headWidth <= 991) {

      jQuery(".dropdownIcon").click(function () {
        jQuery(this).parent().toggleClass("open_sub");
      });

      console.log('jQuery 1234');

  }




$(".vpop").on('click', function(e) {
  e.preventDefault();
  $('#PageContainer').addClass('removeTransform');
  $("#video-popup-overlay,#video-popup-iframe-container,#video-popup-container,#video-popup-close").show();
  
  var srchref='',autoplay='',id=$(this).data('id');
  if($(this).data('type') == 'vimeo') var srchref="//player.vimeo.com/video/";
  else if($(this).data('type') == 'youtube') var srchref="https://www.youtube.com/embed/";
  
  if($(this).data('autoplay') == true) autoplay = '?autoplay=1';
  
  $("#video-popup-iframe").attr('src', srchref+id+autoplay);
  
  $("#video-popup-iframe").on('load', function() {
    $("#video-popup-container").show();
  });
});

$("#video-popup-close, #video-popup-overlay").on('click', function(e) {
  $('#PageContainer').removeClass('removeTransform');
  $("#video-popup-iframe-container,#video-popup-container,#video-popup-close,#video-popup-overlay").hide();
  $("#video-popup-iframe").attr('src', '');
});


// jQuery(".vpop").on('click', function(e) {
//    e.preventDefault();
// 	jQuery(this).parent().parent().addClass('videoShow');
// });


 jQuery('.product-single__thumbnails-new').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: '.product-single__thumbnails'
});
jQuery('.product-single__thumbnails').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.product-single__thumbnails-new',
  focusOnSelect: true,
  arrows: true,
  responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
});


    
jQuery(".accordion-items").click(function(){        
   jQuery(this).closest(".accordion-items").toggleClass("active").slow();
   jQuery(this).closest(".accordion-items").siblings().removeClass("active").slow();   
});

    
jQuery(".searchTab").on('click', function(e) {
	jQuery(".searchTabOpen").addClass('searchOpen');
    e.stopPropagation();
});
  
    
    

    jQuery('a[href="#search"]').on('click', function(event) {                    
    jQuery('#search').addClass('open');
    jQuery('#search > form > input[type="search"]').focus();
    });            
    jQuery('#search, #search .close').on('click keyup', function(event) {
    if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
    jQuery(this).removeClass('open');
    }
    });
    
jQuery('input[name="radio-group"]').on('click',function(){
    if(jQuery(this)[0].checked){
        jQuery('#donationForm input[name="id"]').val(jQuery(this).val())
    }
    
})    




jQuery('.inlineaddtocartform').on('submit',function(e){
  
  	e.preventDefault();
  	var current = $(this);
	var ID = $(this).find('input[name="id"]').val(); 
 	
  	current.find('.addtocartinline ').text('Adding...!')
    
    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: ID
    },
      dataType: 'json', 
     success: function (data) {
       
	  $.ajax({
        type: 'GET',
        url: '/cart.js',
        
          
         success: function (cartData) {
			let raw_data = cartData
			let d = JSON.parse(raw_data)
           
         	$('.cart-Update').html(d.item_count)
           document.dispatchEvent(new Event("cart:updated"));
         } 
       });
       
       
       
      current.find('.addtocartinline ').text('Added to cart!')
      setTimeout(function(){
      	current.find('.addtocartinline ').text('Add again')
      },1000)

     } 
   });
})

if(jQuery('.product-form__bundle-variants').length > 0){
  function bindColorButtons() {
  console.log('Binding color buttons');

  let activeColorIndex = null;
  const selectedColors = ["", ""];
  const hiddenInput = document.getElementById('selected-color-input');
  const submitBtn = document.querySelector('.product-form__cart-submit');
  const buttons = document.querySelectorAll('.add-color-btn');

  buttons.forEach(button => {
    button.addEventListener('click', function (e) {
      if (e.target.closest('.remove-color')) return;
      activeColorIndex = parseInt(this.getAttribute('data-index'), 10);
      document.getElementById('color-popup').style.display = 'block';
    });
  });

  document.querySelectorAll('.remove-color').forEach((removeIcon, index) => {
    removeIcon.addEventListener('click', function (e) {
      e.stopPropagation();

      selectedColors[index] = "";

      const button = buttons[index];
      button.setAttribute('data-selected', 'false');
      const label = button.querySelector('.color-label');
      const img = button.querySelector('img.color-preview');

      if (img) img.remove();

      label.textContent = `Add`;
      this.style.display = 'none';
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.disabled = true;

      updateHiddenInputAndCount();
    });
  });

  const closeBtn = document.querySelector('.popup-header .close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      document.getElementById('color-popup').style.display = 'none';
    });
  }

  document.querySelectorAll('#color-list li').forEach(item => {
    item.addEventListener('click', function () {
      const selectedColor = this.getAttribute('data-color');
      const imgSrc = this.querySelector('img')?.getAttribute('src');
      const imgAlt = this.querySelector('img')?.getAttribute('alt') || selectedColor;

      selectedColors[activeColorIndex] = selectedColor;

      const button = buttons[activeColorIndex];
      button.setAttribute('data-selected', 'true');
      const label = button.querySelector('.color-label');
      const removeIcon = button.querySelector('.remove-color');

      const existingImg = button.querySelector('img.color-preview');
      if (existingImg) existingImg.remove();

      if (imgSrc) {
        const previewImg = document.createElement('img');
        previewImg.src = imgSrc;
        previewImg.alt = imgAlt;
        previewImg.className = 'color-preview';
        button.insertBefore(previewImg, label);
      }

      label.textContent = selectedColor;
      removeIcon.style.display = 'inline-block';

      updateHiddenInputAndCount();
      checkSubmitBtn();
      document.getElementById('color-popup').style.display = 'none';
    });
  });

  window.onclick = function (event) {
    const popup = document.getElementById('color-popup');
    if (event.target === popup) {
      popup.style.display = "none";
    }
  };

  function updateHiddenInputAndCount() {
    const filtered = selectedColors.filter(c => c !== "");
    hiddenInput.value = filtered.join(", ");
    document.getElementById('selected-count').textContent = filtered.length;
  }

  function checkSubmitBtn() {
    const allSelected = Array.from(buttons).every(btn => btn.getAttribute('data-selected') === 'true');
    submitBtn.setAttribute('aria-disabled', allSelected ? 'false' : 'true');
    submitBtn.disabled =  allSelected ? false : true;
  }
}


  bindColorButtons();


  // Check if variant has changed
  window.addEventListener('variantChange', function(event) {
    console.log('Variant changed:', event);
    if(document.querySelector('.product-form__bundle-variants')) {
      const colorSelect = document.getElementById('SingleOptionSelector-0');
      const buttonContainer = document.querySelector('.product-form__bundle-variants-buttons');
      const desiredCount = parseInt(colorSelect.value, 10);
      const submitBtn = document.querySelector('.product-form__cart-submit');
      document.getElementById('selected-count').textContent = 0;
      document.getElementById('total-count').textContent = desiredCount;
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.disabled = true;
      
      buttonContainer.innerHTML = '';
      for (let i = 0; i < desiredCount; i++) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'add-color-btn';
        button.setAttribute('data-index', i);
        button.setAttribute('data-selected', 'false');
        button.innerHTML = `
          <span class="color-label">Add</span>
          <span class="remove-color" style="display: none;">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="0.5" width="24" height="24" rx="12" fill="black"></rect>
              <path d="M9 9.5L15 15.5" stroke="white" stroke-width="1.2" stroke-linecap="round"></path>
              <path d="M15 9.5L9 15.5" stroke="white" stroke-width="1.2" stroke-linecap="round"></path>
            </svg>
          </span>
        `;
        buttonContainer.appendChild(button);
      }
        bindColorButtons();
      }
  });
}